import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import pt_br from './pt_br.json';
import { getCookie } from 'react-use-cookie';

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  lng: getCookie('i18n_locale') ? getCookie('i18n_locale') : 'pt_br',
  resources: {
    en: en,
    pt_br: pt_br
  },
  react: {
    useSuspense: false,
  },
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;